import { ScheduleMeetingIcon } from "../../components/icons/chat-actions/schedule-meet-icon";
import { LiveAgentIcon } from "../../components/icons/chat-actions/live-agent-icon";
import { ActionButton, ChatActionsContainer } from "./styles";
import { Tooltip } from "react-tooltip";
import { useAppDispatch, useAppSelector } from "../../../common/store";
import { useContext, useEffect, useMemo } from "react";
import { VoiceCallIcon } from "../../components/icons/chat-actions/voice-call-icon";
import { VideoIcon } from "../../components/icons/chat-actions/video-icon";
import { EndChatIcon } from "../../components/icons/chat-actions/end-chat-icon";
import { setBookAppointment } from "../../../common/store/theme/theme-slice";
import { BookAppointmentImplementation } from "../../../common/store/theme/constants/book-appointment-implementation";
import { ChatContext } from "../../contexts/chat-context";
import {
  setAvailableSlots,
  setIsWaitingLiveAgent,
} from "../../../common/store/chat/chat-slice";
import { getCallToken } from "../../../common/store/calls/thunks/get-call-token";
import {
  startCall,
  endCall,
  toggleCamera,
  toggleMic,
} from "../../../common/store/calls/calls-slice";
import { postEndLiveAgentChat } from "../../../common/store/chat/thunks/post-end-live-agent-chat";
import CallType from "../../../common/store/calls/types/call-type";
import getBasicLSData from "../../utils/getBasicLSData";
import { TAB_LIST_KEY } from "../../hooks/heartbeat/use-heartbeat";
import { axiosClient } from "../../../common/api/axios-client";
import { HttpStatusCode } from "axios";
import { fetchMeetingDetails } from "../../utils/fetch-meeting-details";
import { setAgentDetails,setMeetingDetails } from "../../../common/store/chat/chat-slice";
import { ButtonBlurrer } from "./ButtonBlurrer";
import { chatSelector } from "../../../common/store/chat/selectors";
const ChatActions = () => {
  const isChattingWithLiveAgent = useAppSelector(
    (state) => state.chat.isChattingWithLiveAgent
  );
  const shouldUseCustomCalendar = useAppSelector(
    (state) => state.chat.customCalendar
  );
  const isOnCall = useAppSelector((state) => state.calls.isOnCall);
  const isMicOn = useAppSelector((state) => state.calls.isMicOn);
  const isCameraOn = useAppSelector((state) => state.calls.isCameraOn);
  const isWaitingLiveAgent = useAppSelector(
    (state) => state.chat.isWaitingLiveAgent
  );
  const merchIdHash = useAppSelector((state) => state["app-state"].merchIdHash);
  const visitorCountryCodeSource = useAppSelector((state) => state["app-state"].visitorCountryCodeSource)
  const visitorCountryCodeKey = useAppSelector((state) => state["app-state"].visitorCountryCodeKey)
  const visitorCountrySource = useAppSelector((state) => state["app-state"].visitorCountrySource)
  const visitorCountryKey = useAppSelector((state) => state["app-state"].visitorCountryKey)
  const quickActionButtons = useAppSelector(
    (state) => state.chat.quickActionButtons
  );
  const { sendUserInput, handleStopWaitingLA } = useContext(ChatContext);
  const dispatch = useAppDispatch();
  const storeMessages = useAppSelector(chatSelector);
  const handleMeetingSchedule = async () => {

    if (
      merchIdHash !==
      "b6783969bc077c42bef036b471e89631d7e6ca9d4f1a6032b5ad2c0e982a7dec"
    ) {
      try {

        const request_obj = {
          ...getBasicLSData(visitorCountryCodeSource, visitorCountryCodeKey, visitorCountrySource, visitorCountryKey),
          frontend_source: "quick_action_calendar",
        };        

        const response = await axiosClient.post(
          "/assign_sales_agent",
          request_obj
        );

        if (response.status !== HttpStatusCode.Ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = response.data;

        dispatch(
          setBookAppointment({
            implementation: BookAppointmentImplementation.CALENDLY,
            calendlyLink: data?.calendar_link,
          })
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleCustomCalendar = async () => {

    const request_obj = {
      ...getBasicLSData(visitorCountryCodeSource, visitorCountryCodeKey, visitorCountrySource, visitorCountryKey),
      frontend_source: "quick_action_calendar",
    };  

    if (
      merchIdHash !==
      "b6783969bc077c42bef036b471e89631d7e6ca9d4f1a6032b5ad2c0e982a7dec"
    ) {
      try {
        const response = await axiosClient.post(
          "/calendar/assign_agent",
          request_obj
        );

        if (response.status !== HttpStatusCode.Ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = response.data;
        dispatch(
          setBookAppointment({
            implementation: BookAppointmentImplementation.CUSTOM_CALENDAR,
            agentEmail : data?.agent_email
          })
        );
      const slots = await fetchMeetingDetails(data.agent_email || "");
      dispatch(setMeetingDetails(slots.meeting_details));
      dispatch(setAgentDetails(slots.agent_details));
      dispatch(setAvailableSlots(slots.available_slots));
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleTalkToAgent = () => {
    if (!sendUserInput) return;

    sendUserInput("Talk to a Live Agent");
    dispatch(setIsWaitingLiveAgent(true));
  };

  const handleEndChat = () => {
    if (isWaitingLiveAgent) {
      handleStopWaitingLA!();
    } else {
      dispatch(postEndLiveAgentChat());
    }
  };
    
  // useEffect(() => {
  //   let isTabClosing = false;

  //   const handleTabClose = () => {
  //     const activeTabs: Record<string, number> = JSON.parse(
  //       localStorage.getItem(TAB_LIST_KEY) || "{}"
  //     );
  //     const shouldEndChat = Object.keys(activeTabs).length < 2;

  //     if (isTabClosing || !shouldEndChat) return;
  //     isTabClosing = true;

  //     const reqBody = {
  //       session_id: appState.sessionId,
  //       conversation_id: appState.conversationId,
  //       su_id: appState.suId,
  //       merch_id: appState.merchId,
  //     };

  //     dispatch(setIsChattingWithLiveAgent(false));
  //     dispatch(setIsWaitingLiveAgent(false));

  //     // Fallback for browsers that don't support sendBeacon
  //     fetch(`${process.env.API_URL}/user/end-ghost-chat`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(reqBody),
  //       keepalive: true, // required to not stop request on close tab
  //     }).catch(() => {});
  //   };

  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "hidden") {
  //       window.addEventListener("pagehide", handlePageHide);
  //     } else {
  //       window.removeEventListener("pagehide", handlePageHide);
  //     }
  //   };

  //   const handlePageHide = (event: PageTransitionEvent) => {
  //     if (!event.persisted) {
  //       handleTabClose();
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //     window.removeEventListener("beforeunload", handleTabClose);
  //     window.removeEventListener("pagehide", handlePageHide);
  //   };
  // }, [
  //   appState.sessionId,
  //   appState.conversationId,
  //   appState.suId,
  //   appState.merchId,
  // ]);

  const handleCall = (id: string) => {
    dispatch(startCall());
    dispatch(toggleMic(true));
    dispatch(toggleCamera(id === "video-call"));
    const type = id === "video-call" ? CallType.VIDEO : CallType.AUDIO;
    dispatch(getCallToken({ type }));
    if (!sendUserInput) return;
    // sendUserInput('Call with a Live Agent');
  };

  const onClickAction = (id: string) => {
    switch (id) {
      case "schedule-meeting":
        if (shouldUseCustomCalendar) {
        handleCustomCalendar();
        }
        else{
        handleMeetingSchedule();
        }
        return;
      case "talk-live-agent":
        handleTalkToAgent();
        return;
      case "end-chat":
        handleEndChat();
        return;
      case "voice-call":
      case "video-call":
        handleCall(id);
        return;
      case "end-call":
        dispatch(endCall());
        return;
      case "mute-video":
        dispatch(toggleCamera(false));
        return;
      case "unmute-video":
        dispatch(toggleCamera(true));
        return;
      case "mute-mic":
        dispatch(toggleMic(false));
        return;
      case "unmute-mic":
        dispatch(toggleMic(true));
        return;
      default:
        return;
    }
  };

  const actions = useMemo(() => {
    const isWaitingOrChattingLA = isChattingWithLiveAgent || isWaitingLiveAgent;
    const result = [];

    if (quickActionButtons.displayLiveAgentConnect) {
      result.unshift({
        id: isWaitingOrChattingLA ? "end-chat" : "talk-live-agent",
        icon: isWaitingOrChattingLA ? <EndChatIcon /> : <LiveAgentIcon />,
        tooltip: isWaitingOrChattingLA ? "End Chat" : "Talk to an Agent",
      });
    }

    if (!isWaitingOrChattingLA && quickActionButtons.displayCalendar) {
      result.unshift({
        id: "schedule-meeting",
        icon: <ScheduleMeetingIcon />,
        tooltip: "Schedule a Meeting",
      });
    }

    if (isChattingWithLiveAgent && !isOnCall) {
      const liveAgentOnly = [
        {
          id: "video-call",
          icon: <VideoIcon />,
          tooltip: "Video Call",
        },
        {
          id: "voice-call",
          icon: <VoiceCallIcon />,
          tooltip: "Voice Call",
        },
      ];

      result.push(...liveAgentOnly);
    }

    if (isOnCall) {
      // remove end-chat from actions
      const endChatIndex = result.findIndex(
        (action) => action.id === "end-chat"
      );
      result.splice(endChatIndex, 1);

      // const callOnly = [
      //   {
      //     id: isCameraOn ? 'mute-video' : 'unmute-video',
      //     icon: isCameraOn ? <VideoIcon /> : <VideoOffIcon />,
      //     tooltip: isCameraOn ? 'Turn Video Off' : 'Turn Video On',
      //   },
      //   {
      //     id: isMicOn ? 'mute-mic' : 'unmute-mic',
      //     icon: isMicOn ? <MicIcon /> : <MicOffIcon />,
      //     tooltip: isMicOn ? 'Turn Mic Off' : 'Turn Mic On',
      //   },
      //   {
      //     id: 'end-call',
      //     icon: <EndCallIcon />,
      //     tooltip: 'End call',
      //   },
      // ]

      // result.push(...callOnly)
    }

    return result;
  }, [
    isChattingWithLiveAgent,
    isOnCall,
    isCameraOn,
    isMicOn,
    isWaitingLiveAgent,
    quickActionButtons,
  ]);
  const isWaitingAnimationOrResponse = useMemo(
    () => storeMessages.isStreamingHandling || !storeMessages.isDoneAnimationBuffer,
    [storeMessages.isStreamingHandling, storeMessages.isDoneAnimationBuffer],
  );
  return (
    <ChatActionsContainer>
      {actions.map((action) => (
        <div key={action.id}>
          <ButtonBlurrer>
          <ActionButton
            onClick={() => onClickAction(action.id)}
            data-tooltip-id={`${action.id}-tooltip`}
            disabled = {isWaitingAnimationOrResponse}
            >
            {action.icon}
          </ActionButton>
          </ButtonBlurrer>

          <Tooltip
            id={`${action.id}-tooltip`}
            content={action.tooltip}
            style={{
              zIndex: 99999999,
            }}
          />
        </div>
      ))}
    </ChatActionsContainer>
  );
};

export default ChatActions;
